import React, { useEffect, useState } from "react";
import { getServicoMonitorado, gerarToken, getHorusUrl } from "../api/apiPainel";
import { format, parseISO } from "date-fns";
import "../styles/PainelMonitoramento.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowsRotate, faGears } from "@fortawesome/free-solid-svg-icons";
import inativo from '../assets/1.png';
import ativo from '../assets/2.png';
import Notificacao from "./Notificacao";
import PainelMonitoramentoBackup from "./PainelMonitoramentoBackup";

const PainelMonitoramento: React.FC = () => {
  const [servicos, setServicos] = useState([]);
  const [urlHorus, setUrlHorus] = useState<string>("");
  const [notification, setNotification] = useState<string | null>(null);
  const fetchData = async () => {
    try {
      const data = await getServicoMonitorado();
      setServicos(data);
    } catch (error) {
      console.error("Erro ao buscar serviços monitorados:", error);
    }
  };
  const fetchUrl = async () => {
    try {
      const data = await getHorusUrl();
      setUrlHorus(data);
    } catch (error) {
      console.error("Erro ao buscar url:", error);
    }
  }
  const handleTooltip = (event: React.MouseEvent<HTMLButtonElement | HTMLAnchorElement, MouseEvent>) => {
    const target = event.currentTarget;
    target.classList.toggle("show-tooltip");
  };

  function notifyUser(message: string): void {
    if (Notification.permission === 'granted') {
      new Notification(message);
    } else if (Notification.permission !== 'denied') {
      Notification.requestPermission().then(permission => {
        if (permission === 'granted') {
          new Notification(message);
        }
      });
    }
  }
  function copyToClipboard(text: string): void {
    navigator.clipboard.writeText(text)
      .then(() => {
        notifyUser('Texto copiado para a área de transferência!');
      })
      .catch(err => {
        console.error('Erro ao copiar o texto: ', err);
        notifyUser('Erro ao copiar o texto.');
      });
  }
  function handleTdClick(event: React.MouseEvent<HTMLTableCellElement>): void {
    const target = event.currentTarget;
    const text = target.textContent || '';
    copyToClipboard(text);
  }

  useEffect(() => {
    const initialize = async () => {
      try {
        await gerarToken();
        fetchData();
        fetchUrl();
        const intervalId = setInterval(fetchData, 10000);
        return () => clearInterval(intervalId);
      } catch (error) {
        console.log("Erro ao inicializar:", error);
      }
    };
    initialize();
  }, []);

  return (
    <>
      <header className="header">
        <div className="title">SMS</div>
        <div className="buttons">
          <div className="tooltip">
            <span className="tooltip-text-position">Atualizar</span>
            <button
              className="button"
              onClick={fetchData}
              onMouseEnter={handleTooltip}
              onMouseLeave={handleTooltip}
            >
              <FontAwesomeIcon icon={faArrowsRotate} className="fa-lg" />
            </button>
          </div>
          <div className="tooltip">
            <span className="tooltip-text-position">Configurações</span>
            <a
              href={urlHorus}
              className="button"
              onMouseEnter={handleTooltip}
              onMouseLeave={handleTooltip}
            >
              <FontAwesomeIcon icon={faGears} className="fa-lg" />
            </a>
          </div>
        </div>
      </header>
      <div className="titulo">
        <h1>Painel de Monitoramento de Serviços</h1>
      </div>
      <div className="table-container">
        <table className="table-action">
          <thead>
            <tr>
              <th >Serviço</th>
              <th >Ativo</th>
              <th >Instalado</th>
              <th className="break-line">Última Atualização</th>
              <th >Logs</th>
            </tr>
          </thead>
          <tbody>
            {servicos.map((servico: any) => (
              <tr className="linha-marcada" key={servico.cdServicoMonitorado}>
                <td data-label="Serviço">{servico.nmServicoMonitorado}</td>
                <td data-label="Ativo">
                  <div className="campo-luz-de-aviso">
                    <img className="luz-de-aviso" src={servico.dmAtivo ? ativo : inativo} alt="Status Ativo" />

                  </div>
                </td>
                <td data-label="Instalado">
                  <div className="campo-luz-de-aviso">
                    <img className="luz-de-aviso" src={servico.dmInstalado ? ativo : inativo} alt="Status Instalado" />
                  </div>
                </td>
                <td data-label="Última Atualização" >
                  <div className="verificacao">
                    {servico.dtUltimaVerificacao ? (
                      <>
                        <span className="verificacao-desktop">
                          {format(parseISO(servico.dtUltimaVerificacao), "dd/MM/yyyy HH:mm:ss")}
                        </span>
                        <span className="verificacao-mobile">
                          {format(parseISO(servico.dtUltimaVerificacao), "dd/MM/yyyy")}
                        </span>
                      </>
                    ) : (
                      "Data não disponível"
                    )}
                  </div></td>
                <td data-label="Logs" className="log" onClick={handleTdClick}>
                  {servico.dsCaminhoLog ? servico.dsCaminhoLog : "Log não disponível"}
                </td>
                {notification && <Notificacao message={notification} />}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <PainelMonitoramentoBackup/>
      <br />
    </>
  );
};

export default PainelMonitoramento;
